import { useState, useCallback } from 'react';
import { useDebounce } from '../../useDebounce';

/**
 * 질의 내역 페이지의 각종 필터 상태(검색, 상태, 기간)를 관리하는 훅.
 */
export const useInquiryFilters = () => {
    const [personalSearch, setPersonalSearch] = useState('');
    const [companyNameSearch, setCompanyNameSearch] = useState('');
    const [companyContentSearch, setCompanyContentSearch] = useState('');
    const [adminCompanySearch, setAdminCompanySearch] = useState('');

    // 디바운스 적용 (500ms 지연)
    const debouncedPersonalSearch = useDebounce(personalSearch, 500);
    const debouncedCompanyNameSearch = useDebounce(companyNameSearch, 500);
    const debouncedCompanyContentSearch = useDebounce(companyContentSearch, 500);
    const debouncedAdminCompanySearch = useDebounce(adminCompanySearch, 500);

    const [statusFilter, setStatusFilter] = useState('all');
    const [sortOrder, setSortOrder] = useState('desc');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const clearDateFilter = useCallback(() => {
        setStartDate('');
        setEndDate('');
    }, []);

    const handleSetStartDate = useCallback((date) => {
        if (!date) {
            setStartDate('');
            return;
        }
        if (endDate && new Date(date) > new Date(endDate)) {
            setEndDate(date);
        }
        setStartDate(date);
    }, [endDate]);

    const handleSetEndDate = useCallback((date) => {
        if (!date) {
            setEndDate('');
            return;
        }
        if (startDate && new Date(date) < new Date(startDate)) {
            setStartDate(date);
        }
        setEndDate(date);
    }, [startDate]);

    return {
        // 검색 상태 (입력창 연결용 - 즉각 반응)
        personalSearch, setPersonalSearch,
        companyNameSearch, setCompanyNameSearch,
        companyContentSearch, setCompanyContentSearch,
        adminCompanySearch, setAdminCompanySearch,
        // 필터 및 정합성
        statusFilter, setStatusFilter,
        sortOrder, setSortOrder,
        startDate, setStartDate: handleSetStartDate,
        endDate, setEndDate: handleSetEndDate,
        clearDateFilter,
        // 전체 필터 객체 (유틸리티 전달용 - 디바운스된 값 사용)
        filters: {
            personalSearch: debouncedPersonalSearch, 
            companyNameSearch: debouncedCompanyNameSearch, 
            companyContentSearch: debouncedCompanyContentSearch, 
            adminCompanySearch: debouncedAdminCompanySearch,
            statusFilter, sortOrder, startDate, endDate
        }
    };
};
